//------------------------------------------------------------------------------
// サイドバー 型定義
//------------------------------------------------------------------------------
// アクション種別
export default {

  // サイドバー開閉状態
  OPEN: 'SIDEBAR/OPEN',
};
